import { render, staticRenderFns } from "./FacetedSearchSettings.vue?vue&type=template&id=24a25670&scoped=true"
import script from "./FacetedSearchSettings.vue?vue&type=script&lang=js"
export * from "./FacetedSearchSettings.vue?vue&type=script&lang=js"
import style0 from "./FacetedSearchSettings.vue?vue&type=style&index=0&id=24a25670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a25670",
  null
  
)

export default component.exports